export interface StoredConditionValue {
  value: unknown;
  available: boolean;
}

export type ResourceConditionValues = Record<string, StoredConditionValue>;

export function storeConditionValue(
  values: ResourceConditionValues,
  key: string,
  value: unknown,
): boolean {
  const available = value !== undefined;
  const current = values[key];
  if (
    current
    && current.available === available
    && Object.is(current.value, value)
  ) {
    return false;
  }

  values[key] = { value, available };
  return true;
}

export function clearStoredComponentStates(
  values: ResourceConditionValues,
): number {
  let removed = 0;
  for (const key of Object.keys(values)) {
    if (!key.startsWith("component-state:")) continue;
    delete values[key];
    removed += 1;
  }
  return removed;
}
